<template>
  <div class="w-full">
    <t-form
      ref="form"
      class="postal-form-step"
      @submit="onSubmit"
      @submit.prevent
    >
      <h6 class="input-header">Vul hier uw postcode in</h6>

      <div class="postal-form-step__form">
        <PostalSeparateInputs
          class="postal-form-step__separate-inputs"
          :error-messages="errorMessages"
          @result="onResult"
          @change="onChange"
        />

        <FormStepSubmitButton
          id="submitPostal"
          class="postal-form-step__btn"
          :text="btnText"
        />
      </div>
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import PostalSeparateInputs from 'chimera/all/components/form/fields/postal/PostalSeparateInputs.nl'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import { useExperiments } from 'chimera/all/composables/useExperiments'
import { SKALE_0014_REDESIGNED_FUNNEL } from 'chimera/all/constants/experiments'
import NextStep from '~/pages/offertes-aanvragen/start.vue'
import { markFunnelEntered } from '~/middleware/VariantGuard.PD-10913'
import VariantNextStep from '~/pages/v2/offertes-aanvragen/start.vue'

export default {
  name: 'PostalFormStep',

  components: {
    FormErrorMessages,
    PostalSeparateInputs,
  },

  extends: AbstractFormStep,

  props: {
    btnText: {
      type: String,
      default: 'Ga verder',
    },
  },

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      // PD-10913 start — read the assignment the homepage already exposed.
      const { getFromStore, isVariant } = useExperiments(this.$store)
      const experiment = getFromStore(SKALE_0014_REDESIGNED_FUNNEL)

      const isRedesign = isVariant(experiment, 1)

      if (isRedesign) {
        markFunnelEntered()
      }

      this.routeTo(isRedesign ? VariantNextStep : NextStep)
      // PD-10913 end
    },
  },
}
</script>
